import React from "react";
import userStorage from "../utils/userStorage";
import { Navigate, useLocation } from "react-router-dom";

// 잘못된 접근 막기
export const ProtectedRoute: React.FC<{
  children: any;
  require: boolean;
}> = ({ children, require }) => {
  const user = userStorage.get();
  const location = useLocation();

  // const { data: webUpdateData } = useGetWebUpdate();

  // admin 경로 접근시
  if (location.pathname === `/admin`) {
    // 유저가 없거나 grade값이 2가 아닌 경우 접근 불가
    if (
      !user ||
      (require && user.grade !== 2) ||
      (require && user.area !== "00000")
    ) {
      alert(`잘못된 접근입니다. 홈 화면으로 이동합니다.`);
      return <Navigate to="/" replace />;
    }
  }

  // 점검중이 아닌데 점검중 페이지 접근
  // if (location.pathname === `/maintenance`) {
  //   let isUpdatingTime =
  //     webUpdateData &&
  //     new Date(webUpdateData.result.start_date) <= new Date() &&
  //     new Date(webUpdateData.result.end_date) >= new Date();

  //   if (require && webUpdateData) {
  //     if (!isUpdatingTime) {
  //       return <Navigate to="/" replace />;
  //     }
  //   }
  // }

  return children;
};
